<template>
    <p class="p" :style="(data[0]&&data[0].name=='vocab')?'text-indent: 0rem;':''">
      <span ref="content"><component :is="'jo' + item.name" v-for="item in data" v-bind:key="item.index" v-bind:data="item.data" v-bind:hideVocab="hideVocab"></component></span>
      <translator v-if="showTranslator && !isDispformula()" :data="transData"></translator>
    </p>
</template>

<script>
    import joinlineformula from '../formula/inlineformula.vue'
    import jodispformula from '../formula/dispformula.vue'
    import joinlinegraphic from '../fig/inlinegraphic.vue'
    import translator from '../../../../commonComponents/translator.vue'

    export default {
        components: {
          joinlineformula,
          jodispformula,
          joinlinegraphic,
          translator
        },
        props: [
            'data',
          'hideVocab'
        ],
      data() {
          return {
            showTranslator: false,
            transData:''
          }
      },
      created() {

      },
      mounted() {
        let parent = this.$parent.$options._componentTag;
        let _this = this;
        if (this.showTrans &&
          (parent === 'josec' || parent === 'abstract' || parent === 'jobody')) {
          if (this.hasInlineformula() && typeof MathJax !== 'undefined') {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub, _this.$refs.content], [_this.getText]);
          } else {
            this.showTranslator = true;
            this.transData = this.data
          }
        }
      },
      methods: {
          getText(){
            this.showTranslator = true;
            if (this.$refs.content) {
//              去掉mathJax渲染重复的公式节点
              let excessDom = this.$refs.content.getElementsByClassName('MJX_Assistive_MathML');
              for(let i = excessDom.length - 1; i >= 0; i--) {
                excessDom[i].parentNode.removeChild(excessDom[i]);
              }
              this.transData = this.$refs.content.innerText.replace(/[\r\n]/g, "");
            } else {
              this.transData = this.data
            }
          },
          isDispformula() {
            for (let i = 0;i < this.data.length; i++){
              if (this.data[i].name == 'dispformula'){
                return true;
              }
            }
            return false;
          },
          hasInlineformula() {
            for (let i = 0;i < this.data.length; i++){
              if (this.data[i].name == 'inlineformula'){
                return true;
              }
            }
            return false;
          }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/maincontent/body/common/p.vue